module.exports = __webpack_public_path__ + "img/highlevel-transparent-logo.ccc45c35.svg";